<template>
<div class="chapter">
<div class="inner_page">
<p class="nonindent"><br/><br/></p>
<p class="nonindent" id="fm1"><em>This book, though fictional in form, is based strictly on historical fact. Everything in it is real or actually happened. And it all began just one year from today.</em></p>
<p class="right">E. A.                      <br/>Wolf Hole, Arizona</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795317361_epub_fm1_r1.vue?cd03ee02